<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <CountryListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import CountryListing from "@/views/pages/admin/country/countryListing";

export default {
    page: {
        title: i18n.t("module.country"),
    },
    components: { Layout, PageHeader, CountryListing },
    data() {
        return {
            title: i18n.t("module.country"),
            items: [
                {
                    text: i18n.t("module.workplace"),
                    href: "/workplaces",
                },
                {
                    text: i18n.t("module.country"),
                    active: true,
                },
            ],
        };
    },
}
</script>
